// hooks/usePayments.js
import { useState, useEffect, useCallback } from 'react';
import { paymentApi } from '../api/payments';
import toast from 'react-hot-toast';

export const usePayments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPayments = useCallback(async () => {
    setLoading(true);
    try {
      const response = await paymentApi.getAll();
      setPayments(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
      toast.error('Failed to fetch payments');
    } finally {
      setLoading(false);
    }
  }, []);

  const addPayment = useCallback(async (data) => {
    try {
      const response = await paymentApi.create(data);
      toast.success('Payment added successfully!');
      await fetchPayments();
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to add payment');
      throw err;
    }
  }, [fetchPayments]);

  const updatePayment = useCallback(async (id, data) => {
    try {
      const response = await paymentApi.update(id, data);
      toast.success('Payment updated successfully!');
      await fetchPayments();
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to update payment');
      throw err;
    }
  }, [fetchPayments]);

  const deletePayment = useCallback(async (id) => {
    try {
      await paymentApi.delete(id);
      toast.success('Payment deleted successfully!');
      await fetchPayments();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to delete payment');
      throw err;
    }
  }, [fetchPayments]);

  useEffect(() => {
    fetchPayments();
  }, [fetchPayments]);

  return { payments, loading, error, fetchPayments, addPayment, updatePayment, deletePayment };
};